import type { ElementType } from 'react';
import Paper from '@mui/material/Paper';
import SvgIcon from '@mui/material/SvgIcon';

interface ImageBannerProps {
  icon?: ElementType;
}

const ImageBanner = ({ icon }: ImageBannerProps) => (
  <Paper variant="checkAvailabilityImageBanner" elevation={0} role="presentation">
    {icon && <SvgIcon component={icon} inheritViewBox />}
  </Paper>
);

export default ImageBanner;
